(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var wa = document.querySelector('.claygo-wa');
    if (wa) wa.blur();
  });

  function claygoMoney(cents) {
    var format =
      (window.FoxTheme && FoxTheme.settings && FoxTheme.settings.moneyFormat) ||
      '{{amount}} TL';
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.Currency.formatMoney) {
      return FoxTheme.Currency.formatMoney(cents, format);
    }
    var major = (Number(cents) || 0) / 100;
    return major.toLocaleString('tr-TR') + ' TL';
  }

  function claygoCartTotal(cart) {
    if (!cart) return 0;
    if (cart.items_subtotal_price != null) return Number(cart.items_subtotal_price) || 0;
    if (cart.total_price != null) return Number(cart.total_price) || 0;
    return 0;
  }

  function claygoFreeShipMessage(cart, thresholdMajor) {
    var total = claygoCartTotal(cart);
    var count = Number(cart && cart.item_count) || 0;
    var thresholdCents = Math.round(thresholdMajor * 100);
    if (count === 0 || total <= 0) return '1.500 TL üzeri ücretsiz kargo';
    if (total >= thresholdCents) return 'Ücretsiz kargo';
    return 'Ücretsiz kargo için ' + claygoMoney(thresholdCents - total) + ' kaldı';
  }

  function claygoApplyFreeShip(cart) {
    document.querySelectorAll('[data-claygo-free-ship]').forEach(function (el) {
      var raw = el.getAttribute('data-threshold') || '1500';
      var thresholdMajor = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
      if (isNaN(thresholdMajor) || thresholdMajor <= 0) thresholdMajor = 1500;
      el.textContent = claygoFreeShipMessage(cart, thresholdMajor);
    });
  }

  function claygoFetchCart(done) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js');
        return res.json();
      })
      .then(done)
      .catch(function () {});
  }

  function claygoInitFreeShip() {
    if (!document.querySelector('[data-claygo-free-ship]')) return;
    claygoFetchCart(claygoApplyFreeShip);
    document.addEventListener('cart:updated', function (event) {
      if (event.detail && event.detail.cart) claygoApplyFreeShip(event.detail.cart);
      else claygoFetchCart(claygoApplyFreeShip);
    });
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      var ev = FoxTheme.pubsub.PUB_SUB_EVENTS && FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate;
      FoxTheme.pubsub.subscribe(ev || 'cart-update', function (event) {
        if (event && event.cart) claygoApplyFreeShip(event.cart);
        else claygoFetchCart(claygoApplyFreeShip);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', claygoInitFreeShip);
  } else {
    claygoInitFreeShip();
  }

  function claygoRevealSrc(img) {
    if (!img) return;
    var src = img.getAttribute('data-claygo-src');
    if (!src || img.getAttribute('data-claygo-ready') === '1') return;
    img.setAttribute('data-claygo-ready', '1');
    img.src = src;
  }

  function claygoLoadHover(wrapper) {
    var box = wrapper && wrapper.querySelector('[data-claygo-hover-src]');
    if (!box || box.getAttribute('data-claygo-loaded') === '1') return;
    var url = box.getAttribute('data-claygo-hover-src');
    if (!url) return;
    box.setAttribute('data-claygo-loaded', '1');
    var img = document.createElement('img');
    img.src = url;
    img.alt = '';
    img.className = 'motion-reduce';
    img.decoding = 'async';
    box.appendChild(img);
  }

  document.addEventListener(
    'pointerenter',
    function (e) {
      var wrap = e.target && e.target.closest && e.target.closest('.product-card__image-wrapper');
      if (wrap) claygoLoadHover(wrap);
    },
    true
  );

  function claygoUnveil(img) {
    if (!img || !window.lazySizes || !window.lazySizes.loader) return;
    window.lazySizes.loader.unveil(img);
  }

  function claygoUnveilSlide(slide) {
    if (!slide) return;
    slide.querySelectorAll('img.lazyload').forEach(claygoUnveil);
  }

  function claygoBindSliderLazy(root) {
    if (!root || root.getAttribute('data-claygo-lazy') === '1') return;
    if (!root.querySelector('img.lazyload')) return;
    root.setAttribute('data-claygo-lazy', '1');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          claygoUnveilSlide(entry.target);
        });
      },
      { root: root, rootMargin: '0px 48px 0px 48px', threshold: 0.01 }
    );
    root.querySelectorAll('.swiper-slide').forEach(function (slide) {
      io.observe(slide);
    });
    if (root.swiper) {
      root.swiper.on('slideChange transitionStart', function () {
        this.slides.forEach(function (slide) {
          if (
            slide.classList.contains('swiper-slide-visible') ||
            slide.classList.contains('swiper-slide-next') ||
            slide.classList.contains('swiper-slide-active')
          ) {
            claygoUnveilSlide(slide);
          }
        });
      });
    }
  }

  function claygoInitSliderLazy() {
    document.querySelectorAll('.swiper').forEach(claygoBindSliderLazy);
    document.querySelectorAll('.swiper-slide-visible, .swiper-slide-active, .swiper-slide-next').forEach(claygoUnveilSlide);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (!e.target.closest('.swiper-button, .swiper-pagination')) return;
    setTimeout(function () {
      document.querySelectorAll('.swiper-slide-visible, .swiper-slide-active, .swiper-slide-next').forEach(claygoUnveilSlide);
    }, 40);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', claygoInitSliderLazy);
  } else {
    claygoInitSliderLazy();
  }
  window.addEventListener('load', claygoInitSliderLazy);
  setTimeout(claygoInitSliderLazy, 400);
  setTimeout(claygoInitSliderLazy, 1200);

  function claygoInitHero(root) {
    if (!root || root.dataset.claygoHeroReady === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.claygo-hero__slide'));
    if (slides.length < 2) return;
    root.dataset.claygoHeroReady = 'true';
    var dots = Array.prototype.slice.call(root.querySelectorAll('.claygo-hero__dot'));
    var i = 0;
    var timer = null;

    function reveal(index) {
      var slide = slides[index];
      if (!slide) return;
      claygoRevealSrc(slide.querySelector('img[data-claygo-src]'));
    }
    function paintDots() {
      dots.forEach(function (dot, index) {
        var on = index === i;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    function go(n) {
      slides[i].style.transform = '';
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      // Aktif + komşu slaytlar yüklenir, gerisi beklemede kalır (görsel bütçesi)
      reveal(i);
      reveal((i + 1) % slides.length);
      reveal((i - 1 + slides.length) % slides.length);
      slides[i].classList.add('is-active');
      paintDots();
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }
    var autoplayMs = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    function play() {
      stop();
      if (!autoplayMs) return;
      timer = setInterval(function () { go(i + 1); }, autoplayMs);
    }

    reveal(1);
    paintDots();

    var prev = root.querySelector('.claygo-hero__nav--prev');
    var next = root.querySelector('.claygo-hero__nav--next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { go(index); play(); });
    });

    // Dokunmatik swipe + mouse drag
    var dragging = false;
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var moved = false;
    var blockClickUntil = 0;

    function dragStart(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest && e.target.closest('.claygo-hero__nav, .claygo-hero__dots')) return;
      dragging = true;
      moved = false;
      dx = 0;
      startX = e.clientX;
      startY = e.clientY;
      stop();
    }
    function dragCancel() {
      dragging = false;
      dx = 0;
      moved = false;
      root.classList.remove('is-dragging');
      slides[i].style.transform = '';
      play();
    }
    function dragMove(e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (!moved && Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) {
        // Dikey kaydırma niyeti — sayfa scroll'una karışma
        dragCancel();
        return;
      }
      if (!moved && Math.abs(dx) > 8) {
        moved = true;
        root.classList.add('is-dragging');
      }
      if (moved) {
        if (e.cancelable) e.preventDefault();
        slides[i].style.transform = 'translateX(' + dx * 0.4 + 'px)';
      }
    }
    function dragEnd() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      slides[i].style.transform = '';
      // Eşik: genişliğin %15'i, en az 40px
      var limit = Math.min(Math.max(root.clientWidth * 0.15, 40), 160);
      var delta = dx;
      if (moved) blockClickUntil = Date.now() + 350;
      dx = 0;
      moved = false;
      if (Math.abs(delta) > limit) go(delta < 0 ? i + 1 : i - 1);
      play();
    }

    function claygoHeroDestroy() {
      stop();
      window.removeEventListener('pointermove', dragMove);
      window.removeEventListener('pointerup', dragEnd);
      window.removeEventListener('pointercancel', dragEnd);
      delete root.dataset.claygoHeroReady;
    }
    root._claygoHeroDestroy = claygoHeroDestroy;

    root.addEventListener('pointerdown', dragStart);
    window.addEventListener('pointermove', dragMove, { passive: false });
    window.addEventListener('pointerup', dragEnd);
    window.addEventListener('pointercancel', dragEnd);
    root.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // Sürükleme yaptıysa slayt linki açılmasın
    root.addEventListener(
      'click',
      function (e) {
        if (Date.now() >= blockClickUntil) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    play();
  }

  function claygoInitHeroes(scope) {
    var context = scope || document;
    if (!context.querySelectorAll) return;
    context.querySelectorAll('[data-claygo-hero]').forEach(claygoInitHero);
  }

  claygoInitHeroes();

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-claygo-hero]').forEach(function (root) {
      if (typeof root._claygoHeroDestroy === 'function') root._claygoHeroDestroy();
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    claygoInitHeroes(event.target);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.header__search-open');
    if (!btn) return;
    e.preventDefault();
    var input = document.querySelector('.header__search input[type="search"]');
    var open = document.body.classList.contains('search-open');
    if (open) {
      document.body.classList.remove('search-open');
      var box = document.querySelector('header predictive-search');
      if (box) box.classList.remove('predictive-search-open');
      if (input) input.blur();
      btn.setAttribute('aria-expanded', 'false');
      return;
    }
    document.body.classList.add('search-open');
    btn.setAttribute('aria-expanded', 'true');
    if (!input) return;
    requestAnimationFrame(function () {
      input.focus();
    });
  });
})();
